import styled from '@emotion/styled';
import { SPACER, GRID } from 'radiance-ui/lib/constants';

const navbarHeight = SPACER.x5large;
const remainingPageHeight = `calc(100vh - ${navbarHeight})`;

export const MainContainer = styled.div`
  background-color: ${({ theme }) => theme.COLORS.background};
  min-height: ${remainingPageHeight};
`;

export const ContentContainer = styled.div`
  margin: 0 auto;
  position: relative;
  padding: 0;
  max-width: ${GRID.xsContentMaxWidth};
`;

export const PageContainer = styled.div`
  min-height: ${remainingPageHeight};
  padding: ${SPACER.xlarge} ${GRID.standardPadding};
  width: 100%;
  position: relative;
`;
